// Auto-generated Afrikaans word lists
// Generated on: Sun Nov  2 01:02:10 AM SAST 2025
// List A: Words that can be selected as daily words
// List B: Additional words that are valid for guessing but not for daily selection

// Words that can be selected as daily words (from list_A.txt)
export const dailyWordList = `
onder
staan
water
begin
teken
klein
groot
hulle
speel
plant
reeds
ander
gehad
goeie
gelei
slegs
gesin
vanaf
vrede
reeks
bring
veral
ooste
bevat
grens
selde
praat
sterk
staat
wewer
groei
groen
broei
plaas
volle
omdat
yster
gegee
asook
verby
noord
stuit
hoort
stryd
skryf
berei
geken
gered
gelet
geoes
beter
getel
gerek
gewei
gereg
gewen
ingee
gerwe
getem
beset
beste
verre
behae
getas
verte
beken
bende
gedek
gelek
reine
beker
belet
betel
edele
reier
steen
gedra
getal
beeld
oneer
gesit
gelas
arend
heers
gewek
afgee
gebed
besem
deels
etter
geheg
genot
gesak
einde
bedel
betas
ester
geveg
gevra
gesag
bedek
enige
afvee
gerig
gevat
gewas
gewin
leier
lener
broer
erken
gevas
opeet
reken
skeer
besit
soene
steel
bedra
besef
gesig
gehef
gelag
gelam
gepas
inlei
steek
weens
veels
bevel
aanja
belas
gemis
gerol
nasie
geuit
smeer
sneeu
weier
engte
erger
geval
gebit
gelid
gemak
gewis
sweer
redes
trane
vreet
beveg
egter
gebal
gelig
gelos
gepla
lelie
seker
speen
vrees
sweet
tereg
bemin
gebad
gebak
gedig
gerus
gewag
jeens
sekte
sesde
skeel
wense
berig
deler
gekap
gekos
gepak
gerou
gewil
opgee
reuse
verag
derde
wreed
engel
boeie
klere
weste
besig
wreek
anker
bedag
breed
gebid
gejag
gesny
gewig
nader
leeus
leuen
messe
newel
smeek
snaar
breek
aflei
gebot
gegun
geruk
kleed
later
lewer
linne
oefen
preek
sekel
vlees
agaat
beval
boete
ewige
geglo
diepe
gerug
greep
kners
lelik
nagte
saans
voete
siter
sleep
stier
wrede
beurt
emmer
kerwe
omgee
snoei
staar
teuel
agter
gekom
afoes
draai
arbei
berus
beurs
byeen
ganse
gesug
goede
helse
insit
kraai
laste
skare
skeef
skend
trone
afwei
diens
berou
dasse
eland
gekou
keuse
koers
laken
slaan
spies
gebod
gekry
bleek
gaste
geluk
graan
hater
insak
sagte
stert
swaer
sweep
tiran
vinne
adder
angel
besny
binne
dooie
dring
geput
innig
kleef
kring
mirre
pleeg
steil
sweef
swewe
alles
vlies
aards
akker
braai
gehou
gedug
gevou
nawel
opeis
skiet
staal
traag
vaste
velle
albei
gebou
darem
fraai
gehul
inrig
kamer
kniel
nadat
maker
manna
naald
staak
stoet
swaai
toets
wemel
bekom
hemel
gevul
hitte
onreg
mooie
orige
samel
wange
ydele
baken
draad
elfde
euwel
gebyt
gelyk
gewys
hange
klaar
harde
insig
kraal
maats
opset
passe
peins
vader
swaar
skone
slawe
tonge
trant
treur
vaart
vraat
boaan
dikte
draak
dreig
gebuk
gekyk
grawe
maand
knaag
kraak
ligte
pitte
skoen
steun
bewus
digte
griek
groet
grote
hamer
inval
kraag
kwaai
prent
rower
skaal
skawe
tafel
spaar
sprei
steur
stoel
strek
valse
afsak
amper
dreun
graag
inlig
koste
krenk
oplet
optel
plein
slaag
somer
wapen
bedug
behou
blaar
gebly
gewyk
gloei
immer
inham
legio
nooit
massa
onsin
opreg
wraak
alarm
baard
dwaas
bebou
bevry
braak
dwing
pleit
praal
skaam
skenk
smaak
sover
vleis
tensy
bewys
afwas
blaas
krans
ledig
onwel
plaat
potte
toorn
troon
sterf
vraag
afdak
farao
bloei
lawwe
milde
slaap
poste
skeur
terug
stand
stank
vermy
vloei
bekyk
buite
halwe
klaag
kuile
nuwes
skaap
skerm
slaaf
smelt
wilde
vloer
afrol
dwaal
goeds
kwaal
loper
ontug
sowel
skans
sodra
strak
afval
blote
brief
doper
dowes
drank
inkom
gouer
kwaad
hutte
kleur
sodat
maagd
minag
muile
salig
smart
snags
soort
almal
swerm
troos
vlieg
aflig
afwag
islam
koper
krank
musse
omver
opdra
opsit
skerp
spelt
stink
stoot
vroeg
swart
wysie
afkap
gloed
groep
kroon
nogal
oniks
opwek
plaag
regop
rykes
skerf
snuit
speur
spoed
spoel
stort
sulke
swoeg
trots
vuile
glans
hewig
langs
selfs
pasga
skelm
slang
strik
vlerk
brand
drink
ivoor
skoon
swerf
vloed
bloed
wyser
afsny
domme
foute
golwe
herfs
inhou
koors
kroos
vloek
sloot
straf
swelg
toewy
afruk
breuk
godin
hetsy
klank
kwart
latyn
links
nodig
onrus
oprig
proef
prooi
skink
skoot
stook
wolwe
afgod
dowwe
offer
omarm
ploeg
rabbi
afkom
ambag
bodem
skrik
ophef
oppas
opsig
uself
vangs
voort
afsku
blyer
bruin
dronk
klink
kruis
poort
sluit
spits
storm
droom
grond
droog
dwang
moord
omvat
skool
skuit
spoor
vlooi
wydte
julle
blits
kasty
oplig
woord
skywe
stamp
vysel
wyfie
optog
skild
sonop
spons
brood
afhou
blind
blink
bloot
boord
bruis
klots
knoop
kruik
nuuts
party
snuif
altyd
vloot
vrywe
bloos
magog
pronk
skrif
skuil
spalk
afwys
galop
stuur
vyand
stuif
stuks
tapyt
vroom
chaos
psalm
opruk
oprys
spook
afgly
afkyk
bruid
jubel
omkap
skuim
stryk
vurig
fluit
krimp
kruip
opkom
tydig
afwyk
jongs
kloof
onryp
skimp
skuur
stomp
skuif
vyfde
pynig
slurp
omkom
ophou
skuld
komyn
opbou
skurf
volop
byval
opkyk
ombou
omhul
klomp
opbly
omkyk
spuug
bykom
rolle
genus
sowat
titel
natal
rugby
meter
gelys
nabye
nobel
roman
stoep
fyner
prins
pryse
fokus
getee
gevee
belee
genie
eteen
geaar
geite
gener
genre
geren
ineen
geset
geste
beier
geler
genek
naeet
benet
besie
eties
gesel
gerem
eeuse
eners
gerat
geure
gewer
etend
gemes
geseg
geute
gewet
aknee
beide
gerep
genis
geves
geleg
taaie
beaam
bereg
bewei
dinee
etaan
gewel
siene
bedes
benat
eiser
gehel
gevel
gewed
meeue
serie
arena
bewer
enema
gearm
gebel
gepel
geram
gesis
getak
inner
dieet
epies
geban
gebek
gekas
gemat
geoor
geril
opeen
deens
etser
gegas
gelit
idees
inent
patee
verge
afend
besin
denne
etiel
getik
ieder
inert
inter
knees
kreet
meent
skeen
verwe
areas
beleg
gekis
gekla
gelak
getap
geweb
kerne
neder
netel
roete
veras
versa
beule
enger
etiek
gedag
gegis
gewit
giere
haaie
inets
inset
keten
reder
regie
skeet
skree
soere
teler
waaie
aring
beits
beman
beuel
erker
gedam
gelil
genls
genut
gerib
henne
inses
leser
mamee
miete
nemer
soete
steeg
tiers
aires
beril
deser
gaele
gekam
gerok
getol
inoes
leone
nerwe
rasie
sarie
seder
senna
setel
soese
tenar
venne
wener
areka
benig
beton
egret
ellie
esker
gegil
gehak
gelap
gevis
intel
kafee
kreek
leste
natte
nefie
repie
sneef
temer
tenue
terra
traer
wesie
arres
awend
bepan
deses
ferie
fiere
gedos
gegor
gemor
geoog
gesif
inhei
knies
mette
preie
raser
regse
relik
seeus
snewe
speer
sweie
agate
assen
aster
deken
enkel
gelui
gemik
gestu
heter
insek
kween
larie
onewe
ratse
sater
sepie
sfeer
tefie
trein
uiter
veter
aanry
bekis
bekla
betig
degen
degie
egaal
gedui
gedun
gehik
gelol
gepag
gesog
gesus
getou
gewik
heser
latei
liewe
ouere
pikee
rekel
roers
seeys
spene
traan
vette
ystee
amien
asiel
behep
bemis
etery
gedip
gedol
gepor
ketel
kneep
krane
linie
manie
oewer
onnie
resep
roewe
smeed
afset
aldae
benut
draer
dreef
gedok
gehap
gejil
gekol
gelok
gepik
gepot
getob
getop
giers
grane
heden
heide
inlek
jaend
opvee
ratel
takie
wekie
agent
aksie
drewe
eweso
gedog
gedut
gemol
gepos
gerys
heler
henna
inleg
inrit
inrye
jaers
karet
kasie
kater
kewer
koele
kreef
laser
opera
raket
rooie
sakie
sedan
semel
siens
tiara
veler
veraf
vries
weder
wiege
adres
armer
belig
epiek
gekog
gelyn
getug
kepie
lewes
naand
nosie
onnet
rebel
repel
skeep
speek
sweem
troei
tsaar
uiers
uitle
verja
wesel
aftel
agens
aitsa
allen
amaas
amens
bekap
benou
beoog
feeks
fries
gedou
gehol
gemok
gewip
indra
inhel
leuse
mater
metra
minne
nagse
nones
operd
orale
orent
puree
rekas
riepa
rosie
sange
snert
tepel
tesis
vesel
aller
bedui
bekaf
benul
deins
gebol
gehok
gelob
gerub
grein
hasie
hegte
inlas
intak
katse
keper
kiaat
kraan
kweek
lakei
lasse
liter
marse
maser
matte
nerts
netto
norse
skewe
slaai
snoer
vraer
afrem
afwen
akkie
akses
basie
belol
gedop
gekul
gemyn
genyg
hakea
inbed
inbel
inkas
kakie
kegel
kreti
lagie
malie
netso
nikse
otter
revue
sepia
skaai
slier
snoet
stoei
toeka
urine
watte
afbie
agste
arkel
baret
bedol
bejag
dader
dalet
delta
delwe
eiwit
fasie
gejol
gekop
gelug
geryg
gerym
gneis
griet
harse
helle
ikone
kaart
kader
kagie
kanna
kemel
klaer
koerd
laars
lange
liste
manel
masse
media
onses
pater
poele
rakel
rioel
riole
roset
skier
snaak
soter
stoer
talle
tatas
traak
uraan
varse
watse
adieu
afpen
alias
aorta
brein
enjin
gebom
gejok
gekys
gespu
getyg
graat
heila
hekel
hiaat
hoera
kadet
katel
kiets
kiste
kitse
knoei
lager
maler
manke
nadra
nanag
nasit
nonna
oplae
opsie
oraal
rapse
rosse
ruier
sebra
skaar
skoea
skrei
slaat
stres
takel
ulane
vedel
voege
welke
woers
aftas
akant
balie
bates
bebos
belus
berug
beuls
boers
disse
emirs
frase
gekug
gepyn
gesyg
gevry
gewyt
giste
graas
hakie
hiert
intik
invat
invra
inwas
inwin
jeans
kaats
kawie
lakse
larwe
lento
lepel
losie
maart
magie
maria
misre
nomen
orden
orrel
peper
poena
praai
radar
rokie
ruite
saals
seraf
skaat
swaan
tabes
truie
uteri
visie
wiens
abses
afdek
aflek
afrit
asbes
basse
belyn
boeta
boewe
dawer
dorre
dosie
drawe
effen
faset
gaats
gebry
gehop
glase
haler
hefte
infra
intap
items
kerns
klier
knoet
kriel
lenig
masel
mites
order
orgie
padie
pekel
roker
rusie
soets
suier
swier
vakie
valer
waker
werda
witte
wring
atlas
baler
bedou
dagse
defek
denim
dinar
direk
draal
enorm
essay
finse
gades
gehys
gejou
geryp
haker
hewel
hiets
inpas
iraki
ismes
karas
moeti
oplei
salwe
skoei
spaan
tibet
vaker
vange
akute
baars
baker
dadel
gefop
gegly
gehug
gepof
grata
indam
inkam
inrol
knoes
kriek
leids
mosie
navra
nouer
opaal
outie
palet
paria
ponie
rafel
skema
sloer
snoek
spier
swael
sweis
tabel
trans
verys
viets
warme
wisse
ylend
afdra
afhel
afsit
aftak
aland
aldan
aslas
aswan
begyn
bevog
blaai
blein
debat
draag
drenk
gejuk
graad
harem
hawer
idole
jaart
jitte
kroes
luier
menig
oktet
opaak
orkes
piets
rysie
sabel
sauna
skore
slaak
snars
sonar
uniek
afarm
belug
berym
bonte
bygee
fiets
gaper
gewyd
gidse
glaas
inlos
inwag
koets
kraam
kuier
malle
miaau
notas
omega
ovale
pakte
regaf
rodeo
rofie
sanik
sedig
skaad
skaak
skets
skote
snerp
snoue
spaat
staaf
stief
strem
totem
tower
wasem
afmat
afoor
apart
apeks
aroma
aspek
daags
galge
gehup
gemuf
hoeka
inkap
inpak
intog
kalme
kille
kreun
omset
opwen
papie
pienk
poise
snyer
sopie
swoer
sysie
troue
briek
dekor
doder
doepa
gehyg
gepyl
impie
inlui
kanon
knaap
omlei
oopte
otjie
patat
radio
sadis
sisal
spens
swets
tibia
troep
woema
afrig
aftik
afvat
afvra
afwin
agtal
basta
drama
effek
griep
intou
japie
josie
kabel
klets
kliek
kneus
koker
kroek
loket
nuwer
opbie
pasta
sleur
troef
braam
haaks
hernu
inlok
insny
inwig
kapel
karma
koala
kroeg
liefs
lopie
lower
lysie
moker
motel
noors
ovaal
poema
priem
proes
rykie
salon
swenk
tersy
video
afdag
afpas
bisar
derms
fikse
graaf
inpik
kaaps
libel
louer
luide
lusse
moles
njala
opper
orals
ouder
panda
poets
psige
hotel
hunse
ikoon
kakao
kopie
kouer
oprit
panga
serum
sjeik
sjiek
skaaf
vroed
welig
wilge
ysige
atoom
basis
bleik
broek
kwaak
kwets
myner
onmin
oskar
riool
ryker
stoor
swiep
tabak
wafel
welaf
wroeg
afhak
aflos
aldag
asbak
bloes
braaf
drang
droef
fliek
hoeks
swaap
joune
onpas
ookal
power
sinus
tempo
dwerg
frats
inryg
kurwe
malva
padda
skoor
sluwe
snork
vodde
duvet
dwars
inhul
magma
mamma
omsit
opvat
speld
klits
kajak
nudis
smoor
trust
tjank
vygie
duits
radys
skors
swink
torus
boots
front
gruis
kiosk
kolon
oplos
pakos
plooi
plank
stoof
regby
syweg
dogma
flits
kruid
komma
folio
pasop
spuit
afbyt
opdok
fonds
blaps
bybel
visum
bolip
skrum
gluur
balju
luuks
pluim
wawyd
bydam
omvou
gholf
`;

// Combined word list for validation (list_A.txt + list_B.txt)
// This includes all words that can be submitted as guesses
export const validWordList = `
onder
staan
water
begin
teken
mense
klein
groot
hulle
speel
plant
reeds
ander
gehad
goeie
gelei
slegs
gesin
vanaf
vrede
reeks
bring
veral
ooste
regte
bevat
grens
selde
praat
sterk
staat
wewer
rotse
groei
groen
magte
broei
plaas
volle
omdat
yster
gegee
asook
verby
noord
stuit
hoort
stryd
skryf
berei
geken
gered
gelet
geoes
beter
getel
gerek
gewei
gereg
gewen
ingee
gerwe
getem
beset
beste
verre
behae
getas
verte
beken
bende
gedek
gelek
reine
beker
belet
betel
edele
reier
steen
gedra
getal
beeld
oneer
gesit
riete
gelas
arend
heers
gewek
nette
afgee
gebed
besem
deels
etter
geheg
genot
gesak
neste
einde
stene
bedel
betas
ester
geveg
gevra
gesag
bedek
enige
afvee
kenne
gerig
gevat
gewas
gewin
leier
lener
broer
erken
gevas
opeet
reken
skeer
besit
soene
steel
bedra
besef
gesig
gehef
gelag
gelam
gepas
inlei
steek
weens
veels
bevel
aanja
belas
gemis
gerol
nasie
geuit
smeer
sneeu
weier
engte
erger
geval
gebit
gelid
gemak
gewis
sweer
redes
trane
vreet
beveg
egter
gebal
gelig
gelos
gepla
lelie
neute
penne
seker
snare
speen
vrees
sweet
tereg
bemin
gebad
gebak
gedig
gerus
gewag
jeens
sedes
sekte
sesde
skeel
wense
berig
deler
gekap
gekos
gepak
gerou
gewil
opgee
reuse
verag
sinne
swere
wette
derde
wreed
engel
boeie
klere
weste
wiele
besig
wreek
anker
bedag
breed
diewe
gebid
gejag
gesny
gewig
hoere
nader
leeus
leuen
messe
newel
perse
smeek
snaar
breek
aflei
gebot
gegun
geruk
kleed
later
lewer
linne
oefen
preek
sekel
vlees
agaat
beval
boete
ewige
geglo
deure
diepe
gerug
greep
kners
latte
lelik
nagte
saans
voete
siter
sleep
stier
wrede
beurt
emmer
kerwe
omgee
snoei
staar
teuel
agter
gekom
afoes
draai
arbei
berus
beurs
byeen
ganse
gesug
goede
helse
insit
kraai
laste
skare
skeef
skend
trone
afwei
diens
berou
dasse
eland
gekou
keuse
koers
laken
slaan
spies
gebod
gekry
bleek
gaste
geluk
graan
hater
insak
sagte
stert
swaer
sware
sweep
tiran
vinne
vrate
adder
angel
besny
binne
dooie
dring
geput
innig
kleef
kring
mirre
pleeg
steil
sweef
swewe
alles
tuine
vlies
aards
akker
braai
gehou
gedug
gevou
klewe
nawel
opeis
skiet
staal
traag
vaste
velle
albei
gebou
darem
fraai
gehul
inrig
kades
kamer
kniel
nadat
maker
manna
naald
staak
stoet
swaai
toets
wemel
bekom
hemel
gevul
hitte
onreg
mooie
orige
samel
wange
ydele
dinge
baken
blare
draad
elfde
euwel
gebyt
gelyk
gewys
hange
klaar
harde
insig
kraal
maats
opset
passe
peins
vader
swaar
skone
slawe
tonge
trant
treur
vaart
vraat
boaan
dikte
draak
dreig
dwase
gebuk
gekyk
grawe
maand
knaag
kraak
ligte
pitte
skoen
steun
bewus
digte
griek
groet
grote
hamer
inval
kraag
kwaai
peule
plate
prent
rower
skaal
skawe
tafel
spaar
sprei
steur
stoel
strek
valse
visse
wagte
afsak
amper
dreun
graag
inlig
koste
krenk
kruie
motte
oplet
optel
plein
slaag
somer
togte
wapen
bedug
behou
blaar
gebly
gewyk
gloei
immer
inham
legio
nooit
massa
onsin
opreg
wraak
alarm
baard
dwaas
bebou
bevry
braak
dwing
kwade
kwale
pleit
praal
skaam
skenk
smaak
sover
vleis
tensy
bewys
afwas
blaas
krans
ledig
onwel
plaat
potte
toorn
troon
spore
sterf
vraag
afdak
farao
bloei
lawwe
milde
slaap
poste
skeur
skure
terug
stand
stank
wille
vermy
vloei
bekyk
buite
halwe
klaag
kuile
nuwes
skaap
skerm
slaaf
smelt
wilde
vloer
afrol
dwaal
goeds
kwaal
loper
ontug
sowel
skans
sodra
strak
afval
blote
brief
doper
dowes
drank
inkom
gouer
kwaad
hutte
kleur
sodat
maagd
minag
muile
salig
smart
snags
soort
almal
swerm
troos
vlieg
aflig
afwag
islam
koper
krank
musse
omver
opdra
opsit
skerp
spelt
stink
stoot
vroeg
swart
wysie
afkap
duiwe
gloed
groep
kroon
molle
nogal
oniks
opwek
plaag
regop
rykes
skerf
snuit
speur
spoed
spoel
stort
sulke
swoeg
trots
vuile
glans
hewig
houte
langs
selfs
pasga
skelm
slang
strik
vlerk
brand
drink
ivoor
skoon
swerf
vloed
bloed
wyser
afsny
domme
foute
golwe
herfs
inhou
koors
kroos
vloek
sloot
straf
swelg
toewy
afruk
breuk
godin
hetsy
klank
kwart
latyn
links
nodig
onrus
oprig
proef
prooi
skink
skoot
stook
wolwe
afgod
dowwe
offer
omarm
ploeg
rabbi
afkom
ambag
bodem
skrik
ophef
oppas
opsig
uself
vangs
voort
afsku
blyer
bruin
dronk
klink
kruis
poort
sluit
spits
storm
droom
grond
droog
dwang
moord
omvat
skool
skuit
spoor
vlooi
wydte
julle
blits
kasty
oplig
woord
skywe
stamp
vysel
wyfie
optog
skild
sonop
spons
brood
afhou
blind
blink
bloot
boord
bruis
klots
knoop
kruik
nuuts
party
snuif
altyd
vloot
vrywe
bloos
magog
pronk
skrif
skuil
spalk
afwys
galop
stuur
vyand
stuif
stuks
tapyt
vroom
chaos
psalm
opruk
oprys
spook
afgly
afkyk
bruid
joods
jubel
omkap
skuim
stryk
vurig
fluit
krimp
kruip
opkom
tydig
afwyk
jongs
kloof
onryp
skimp
skuur
stomp
skuif
vyfde
pynig
slurp
omkom
ophou
skuld
komyn
opbou
skurf
volop
byval
opkyk
ombou
omhul
klomp
opbly
omkyk
spuug
bykom
rolle
genus
state
sowat
titel
natal
karoo
rugby
meter
gelys
nabye
skole
nobel
roman
stoep
april
fyner
prins
pryse
fokus
getee
gevee
belee
genie
eteen
geaar
geite
gener
genre
geren
ineen
geset
geste
beier
geler
genek
naeet
benet
besie
eties
gesel
genii
gerem
eeuse
eners
gebie
gerat
geure
gewer
seeue
afeet
etend
gemes
geseg
geute
gewet
aknee
beide
gerep
genis
geves
geleg
taaie
beaam
bereg
bewei
dinee
etaan
gewel
siene
bedes
benat
eiser
gehel
gevel
gewed
meeue
oreer
reise
serie
arena
bewer
enema
gearm
gebel
gepel
geram
gesis
getak
inner
dieet
epies
geban
gebek
gekas
gemat
geoor
geril
laaie
opeen
seise
serre
deens
etser
gegas
gelit
gerot
idees
inent
kaaie
liere
patee
reste
sense
snese
stere
tette
verge
afend
besin
denne
ertse
etiel
getik
ieder
inert
inter
knees
kreet
meent
roere
sette
skeen
verwe
areas
beleg
gekis
gekla
gelak
getap
geweb
kerne
neder
netel
roete
veras
versa
arrie
beule
enger
etiek
gedag
gegis
gewit
giere
haaie
inets
inset
keten
reder
regie
skeet
skree
soere
teler
waaie
aring
beits
beman
beuel
erker
gedam
gelil
genls
genut
gerib
henne
inses
leser
mamee
miete
nemer
nenta
sesse
skeie
soete
steeg
tiers
aires
beril
deser
gaele
gekam
gerok
getol
inoes
leone
nerwe
rasie
sarie
seder
senna
setel
soese
tenar
venne
wener
areka
benig
beton
egret
ellie
esker
gegil
gehak
gelap
gevis
intel
kafee
kreek
leste
natte
nefie
repie
sneef
temer
tenue
terra
traer
wesie
arres
awend
bepan
deses
ferie
fiere
gedos
gegor
gemor
geoog
gesif
inhei
knies
mette
preie
raser
regse
relik
seeus
snewe
speer
sweie
agate
assen
aster
deken
ekses
enkel
gelui
gemik
gestu
heter
insek
kween
larie
onewe
ratse
sater
sepie
sfeer
tefie
trein
uiter
veter
aanry
bekis
bekla
betig
degen
degie
egaal
gedui
gedun
gehik
gelol
gepag
gesog
gesus
getou
gewik
heser
latei
liewe
ouere
pikee
rekel
roers
seeys
spene
traan
vette
ystee
amien
asiel
behep
bemis
etery
gedip
gedol
gepor
ketel
kneep
krane
linie
manie
oewer
onnie
resep
roewe
smeed
afset
aldae
benut
draer
dreef
gedok
gehap
gejil
gekol
gelok
gepik
gepot
getob
getop
giers
grane
heden
heide
inlek
jaend
opvee
ratel
takie
vleie
voere
wekie
agent
aksie
drewe
eweso
gedog
gedut
gemol
gepos
gerys
heler
henna
inleg
inrit
inrye
jaers
karet
kasie
kater
kewer
koele
kreef
laser
opera
raket
rooie
sakie
sedan
semel
siens
tiara
veler
veraf
vries
weder
wiege
adres
armer
belig
epiek
gekog
gelyn
getug
kepie
lewes
naand
nosie
onnet
rebel
repel
sanna
skeep
speek
sweem
troei
tsaar
uiers
uitle
verja
wesel
aftel
agens
aitsa
allen
amaas
amens
bekap
benou
beoog
feeks
fries
gedou
gehol
gemok
gewip
indra
inhel
katte
leuse
mater
metra
minne
nagse
nones
operd
orale
orent
penna
puree
rekas
riepa
rosie
sange
snert
tepel
tesis
vesel
aller
bedui
bekaf
benul
deins
gebol
gehok
gelob
gerub
grein
hasie
hegte
inlas
intak
katse
keper
kiaat
kraan
kweek
lakei
lasse
liter
marse
maser
matte
nerts
netto
norse
ralle
skewe
slaai
snoer
vraer
afrem
afwen
akkie
akses
basie
belol
gedop
gekul
gemyn
genyg
hakea
inbed
inbel
inkas
kakie
kegel
kreti
lagie
malie
netso
nikse
otter
revue
sepia
skaai
slier
snoet
stoei
toeka
urine
watte
afbie
agste
arkel
asems
baret
bedol
bejag
dader
dalet
delta
delwe
eiwit
fasie
gejol
gekop
gelug
geryg
gerym
gneis
griet
harse
helle
ikone
kaart
kader
kagie
kanna
kemel
kepse
klaer
koerd
laars
lange
liste
manel
masse
media
onses
pater
poele
rakel
rioel
riole
roset
skier
snaak
soter
stoer
talle
tatas
traak
uraan
varse
watse
adieu
afpen
alias
aorta
brein
enjin
gebom
gejok
gekys
gespu
getyg
graat
heila
hekel
hiaat
hoera
kadet
katel
kiets
kiste
kitse
knoei
lager
lisse
maler
manke
nadra
nanag
nasit
nonna
oplae
opsie
oraal
rapse
rosse
ruier
ryers
sebra
skaar
skoea
skrei
slaat
spare
stote
stres
takel
ulane
vedel
voege
welke
woers
aftas
akant
balie
bates
bebos
belus
berug
beuls
boers
disse
emirs
fatte
felle
frase
gekug
gepyn
gesyg
gevry
gewyt
giste
graas
hakie
hiert
intik
invat
invra
inwas
inwin
jeans
kaats
kales
kawie
klase
lakse
larwe
lento
lepel
lorre
losie
maart
magie
maria
misre
nomen
orden
orrel
peper
poena
praai
radar
rokie
ruite
saals
seraf
skaat
swaan
tabes
truie
uteri
visie
wiens
abses
acres
afdek
aflek
afrit
agaam
alras
asbes
asdan
basse
belyn
boeta
boewe
dawer
dorre
dosie
drawe
dweep
effen
eksak
falie
faset
fiela
gaats
gasel
gawie
gebry
gehop
glase
haler
hefte
hosea
idose
infra
intap
items
kabie
katar
kerns
klier
knoet
kriel
lenig
masel
meule
mites
nepal
nigel
oeros
order
orgie
padie
pekel
roker
rusie
soets
suier
swier
vakie
valer
waker
welwe
werda
witte
wring
atlas
baler
bedou
dagse
dames
defek
denim
dinar
direk
donse
draal
enorm
essay
fases
finse
gades
gehys
gejou
geryp
haker
hewel
hiets
inpas
iraki
ismes
karas
moeti
oplei
salwe
skoei
spaan
tibet
vaker
vange
akute
baars
baker
dadel
gefop
gegly
gehug
gepof
grata
halse
indam
inkam
inrol
jasse
knoes
kriek
leids
mosie
navra
nouer
opaal
outie
palet
paria
ponie
rafel
skema
sloer
snoek
spier
swael
sweis
tabel
trans
verys
viets
warme
wisse
ylend
afdra
afhel
afsit
aftak
aland
aldan
aslas
aswan
begyn
bevog
blaai
blase
blein
debat
draag
drenk
gejuk
graad
harem
hawer
idole
jaart
jitte
kroes
luier
menig
oktet
opaak
orkes
piets
rysie
sabel
sauna
skore
slaak
snars
sonar
stole
uniek
afarm
afbel
belug
berym
bonte
bygee
fiets
gaper
gewyd
gidse
glaas
inlos
inwag
klone
koets
kraam
kuier
malle
miaau
notas
omega
oprek
ouens
ovale
pakte
regaf
resus
rodeo
rofie
sanik
sedig
skaad
skaak
skets
skote
snerp
snoue
spaat
staaf
stief
strem
tanig
totem
tower
vagte
wasem
afmat
afoor
apart
apeks
aroma
aspek
daags
duite
galge
gehup
gemuf
hoeka
inkap
inpak
intog
kalme
kille
kreun
omset
opwen
papie
pienk
poise
snyer
sopie
swoer
sysie
troue
briek
dekor
doder
doepa
gehyg
gepyl
impie
inlui
kanon
knaap
mekka
omlei
oopte
otjie
patat
radio
sadis
sisal
spens
swets
tibia
troep
woema
afrig
aftik
afvat
afvra
afwin
agtal
basta
drama
effek
griep
intou
japie
josie
kabel
klets
kliek
kneus
koker
kroek
loket
nuwer
opbie
pasta
sleur
troef
braam
haaks
hernu
inlok
insny
inwig
kapel
karma
koala
kroeg
liefs
lopie
lower
luste
lysie
moker
motel
noors
ovaal
poema
priem
proes
rykie
salon
souse
swenk
tapir
tersy
video
afdag
afpas
bisar
derms
fikse
graaf
inpik
kaaps
libel
louer
luide
luike
lusse
moles
njala
opper
orals
ouder
panda
poets
psige
hotel
hunse
ikoon
kakao
kopie
kouer
oprit
panga
serum
sjeik
sjiek
skaaf
vroed
welig
wilge
ysige
atoom
basis
bleik
broek
kwaak
kwets
myner
onmin
oskar
riool
ryker
stoor
swiep
tabak
wafel
welaf
wroeg
afhak
aflos
aldag
asbak
bloes
braaf
drang
droef
fliek
hoeks
swaap
joune
onpas
ookal
power
sinus
tempo
dwerg
frats
inryg
kurwe
malva
padda
skoor
sluwe
snork
vodde
duvet
dwars
inhul
magma
mamma
omsit
opvat
speld
klits
kajak
nudis
smoor
trust
tjank
vygie
duits
radys
skors
swink
torus
boots
front
gruis
kiosk
kolon
oplos
pakos
plooi
plank
stoof
regby
syweg
dogma
flits
kruid
komma
folio
pasop
spuit
afbyt
opdok
fonds
blaps
bybel
visum
bolip
skrum
gluur
balju
luuks
pluim
wawyd
bydam
omvou
gholf
niere
miere
seile
siele
oeste
koeie
paaie
ringe
krale
stawe
sotte
gange
hoewe
skale
slote
motte
plase
sorge
walle
bosse
putte
style
vroue
bolle
klowe
kloue
drywe
bulle
olywe
julie
japan
beige
nawee
seine
laere
renet
eetwa
entre
genua
gewan
berin
allee
roeie
janee
nelie
sesie
gekef
riele
toere
anale
gerui
kamee
lense
liese
tinea
tesse
agies
baaie
kiese
narre
teder
wenne
anter
gedor
krete
reune
skene
kerse
neefs
rewer
seran
stele
apies
keile
kiele
lesse
neuse
ratte
skete
smere
anaal
assie
biese
dries
feite
sekse
tsare
artse
moere
pense
rasse
seges
stewe
vrese
kieue
merel
nonne
olies
oorde
pette
salie
selle
stase
tasse
unies
vetes
woere
yssee
boere
emoes
frese
hesse
kiewe
range
ritte
selek
sfere
stein
sweed
danse
doele
kanse
karre
nisse
peile
peste
ritse
tange
arias
fesse
krewe
lelle
oases
ogies
omies
sagie
tonne
grate
heles
sonne
sooie
stale
aktes
gatte
hanse
hekse
kaste
swane
werwe
litte
maste
mates
pelse
rotte
sakse
spele
temas
gasse
sages
sones
spane
store
asyne
atome
finne
tuite
lotte
nutte
tenks
duine
ivore
ordes
fooie
lyers
ruste
trems
wakse
welpe
russe
kosse
kuite
luise
worse
ampte
balle
disas
fakse
gille
guite
hawes
jagte
kalwe
kuise
longe
soute
stowe
tolle
valle
wigte
klote
hakke
halme
kodes
lamas
vosse
knoue
nulle
poses
siwwe
horde
korwe
modes
pairs
pille
sappe
sugte
kolle
lapas
ligas
borge
kouse
aande
aarde
abdis
abdye
ablou
abrup
abuis
accra
acton
afbid
afbou
afdae
afdig
afdop
afdun
afhap
afhok
afhol
afhys
afjak
afkop
afkou
afkry
aflui
afpak
afpik
afpyl
aftob
aftog
aftop
afvry
afvyl
afwip
agave
aguur
ajoos
akuut
album
aldus
alkyn
allig
almag
alwys
amebe
amorf
ampas
ampul
anode
anzac
appel
aptyt
armes
arums
asbok
asbos
asbus
asdic
aslyn
asuur
athol
augur
babas
bakke
balke
bande
banjo
banke
baroe
barok
basil
baske
batig
batik
batos
bedde
bekke
bemes
berde
berge
berke
beuke
biere
bilal
birma
bison
bivak
bizar
blaam
blank
blond
bloue
blyke
boarm
bobly
bobou
bobyn
bodek
bodes
boeke
bogte
bohou
bojan
bokas
bokke
bokom
bokry
bokse
bokwa
bolae
bolig
bolla
bolug
bolus
bolyf
bomme
bonde
bongo
bonus
boort
bopad
borde
borok
boron
bosak
boude
bouer
boute
bowle
brame
bravo
brits
brode
brons
broos
bruto
bruut
bryer
buike
bukse
bulte
burge
bursa
buryn
busse
buurt
bybly
bybou
bydra
bygif
byhou
bykos
bykry
bylae
bylas
bylyn
bymot
bynes
bypas
byrol
byset
bysin
bysit
bysny
byson
bysyn
bytel
byter
byvak
byvul
bywas
bywyf
cadac
canto
caput
carte
casus
catss
chemo
chiem
chili
china
circa
circe
cirri
cobol
colon
comme
corps
coups
credo
dagga
dagha
dagon
dakke
dalks
damme
dampe
danke
dassy
datum
davib
davit
dawid
decor
dekke
denke
deuke
dhows
dicta
diere
digby
dingo
diode
ditsy
ditto
djati
doeke
dokke
dolby
dolce
dolke
dolos
dolwe
domba
donga
donor
doods
doppe
dorpe
dorps
dorte
dosis
dosyn
drade
drake
drome
druif
druil
druip
druis
dubio
duces
duike
duime
dunte
dupes
duplo
durwe
duske
duwwe
dwelm
echec
edeme
eelte
eende
eiers
ekspo
eksug
esels
eters
etude
eunug
evavy
fabel
facta
facto
fagot
fakir
falli
famsa
fango
fatum
fauna
fecit
femur
ferme
fetus
fiche
fichu
films
fingo
fiool
firma
fisis
fjord
flair
flank
flans
flaps
flard
fleim
fleur
flink
flint
flirt
floks
flora
flous
fluim
fluks
fnuik
fobie
force
forma
forte
foton
fotos
foyer
frank
frans
freud
frons
fugas
fuike
fuiwe
fungi
fynte
galme
galms
galon
gamma
garde
gatry
gauss
gavot
gawes
geboe
gedas
gedoe
gejas
gekke
gelae
gelde
geles
genes
gepes
gesae
gespe
gewae
ghaap
ghaip
ghape
gheip
ghong
ghrok
ghrop
ghwar
ghwel
gibus
gieke
gigue
gilde
ginds
giraf
girts
giwwe
gleuf
glief
glimp
glips
globe
glooi
gloor
gluip
glyer
gnoom
gogel
gogga
gopse
gorde
gorgo
gouda
gouds
grade
grepe
grime
groef
groos
gryns
gryse
guano
gulde
gulpe
gummi
gysel
habyt
hallo
halms
halte
hamba
hamme
hande
hanou
happe
harig
harke
harpe
harpy
harte
hatig
hawik
hekke
helde
helms
hemde
henry
herde
herte
hertz
herwy
heryk
heupe
hinde
hindi
hings
hippe
hoede
hoeke
hofie
hokke
holis
holte
homme
hompe
honde
honds
honou
hoofs
hoogs
hopie
hoppe
horig
horte
hotom
houer
houri
huide
huige
huike
huise
hulde
hulpe
hulse
humor
humus
huppe
hupse
hurke
husse
hydra
hyser
idool
igloe
ilium
imago
impak
inbly
inbou
inbuk
inbyt
incus
indyk
ingly
inhok
injae
inkry
inkyk
inlae
inlyf
inlys
inpyl
insae
insyg
invog
invou
invul
invyl
jabot
jafel
jakke
jakob
jalap
jambe
janus
japon
jarig
javel
jesus
jingo
jobas
jodel
jodin
jolig
jolyt
jonas
jonge
jonke
jopie
joppe
jorik
joris
josef
josia
jouer
joule
judas
judea
jukka
jukke
jukos
junta
junto
juris
jurke
jutse
kabab
kadot
kafir
kalot
kamma
kamme
kamos
kampe
kanne
kante
kapok
kapot
kappa
kappe
kapwa
kargo
karpe
karwy
katyf
kebab
kelke
kelte
kerke
keuls
kieke
kieme
kikke
kimme
kinds
kinke
klamp
klede
kledy
klong
klont
kloon
kloot
klops
klubs
kluif
kluis
kluit
kluts
kluwe
kmdmt
knaks
knape
knope
knots
knuis
knype
kobra
koeke
kofia
kokar
kokke
kokon
kolke
kolom
kolos
kolwe
komaf
komas
kombi
komme
konka
konus
konyn
kooks
koord
kopal
kopek
koppe
korfu
koris
korps
korte
kosak
kosyn
krake
krame
kramp
kreuk
krink
kript
kruim
kruin
kruit
kruks
kubis
kubus
kudde
kuipe
kuiwe
kunde
kupel
kupie
kuras
kurke
kusek
kwant
kwark
kwilt
kwint
kwota
kyker
kykie
labda
laers
lakke
lamme
lampe
lande
lappe
largo
laude
lekke
lemme
lemur
lende
lente
lepus
ligsy
linde
linte
lippe
lobbe
locum
loepe
lofui
logge
logos
lokke
lokus
lompe
lonke
lonte
loods
loops
lords
lotto
lotus
lowwe
lugte
luime
lumen
lupus
lyfie
lykwa
lynch
lyste
lywal
lywig
macho
madam
magou
makis
makou
makro
maksi
mamba
mango
manne
mappe
marke
marog
matig
matzo
mauve
maxim
mebos
meide
melde
merke
mezzo
midde
miede
mikro
minim
minus
mioop
mirte
mispa
misry
model
modem
modus
moede
mofet
mofos
mogol
mokka
moksa
moleg
molik
molog
molwa
momme
monde
monis
moois
moors
moppe
motby
motor
motto
mowwe
mudde
mufti
muise
mukus
mulat
mungo
munte
muses
muwwe
mymer
myter
nably
nabob
nabot
nadae
naels
nahol
nahou
nakom
nakyk
namib
naoes
napos
napyn
naruk
nasny
nasou
nawys
nekke
nihil
nizam
njord
nodus
nokke
noppe
norme
novas
novum
nozem
nukke
nurks
nydig
nylon
nywer
obiit
objek
obole
obool
odium
ogief
ogpoe
ojief
okapi
omber
omdol
omdop
omdra
omhou
omkry
omlyn
omlys
ompad
ompak
ompas
ompik
omrol
omruk
omsig
omsny
omtak
omtas
omval
omwal
omweg
omwip
ondig
onfyn
onlus
onmag
onnut
ontwy
ontyd
onvas
onvry
onwil
onwis
onwys
oonde
oorly
oorsy
ooryl
oossy
opbel
opbod
opbol
opbos
opdam
opdat
opdis
opdop
ophap
ophel
ophop
ophys
opium
opkam
opkap
opkry
oplap
oplug
oplui
oppak
oppik
oppof
oppor
oppot
oprol
oprui
opryg
opsny
opsom
opstu
opval
opvis
opvou
opvra
opvul
opwag
opwas
opwel
opwin
opwip
orbis
origo
orlon
oscar
oskop
osoog
osoon
osvel
otpot
oubos
oubul
oudag
oudak
oudit
ouers
ougat
oulap
oulik
oulyf
ouman
oumas
ounag
ouooi
oupas
ousus
outis
ouwyf
paaps
padaf
padop
pakke
pakys
palms
palpe
palts
pampa
pande
panne
pante
papel
papil
papis
pappa
pappe
parke
parma
parow
parte
parys
passu
patio
patos
pekko
perde
perke
picot
pieke
piepe
piere
pikas
pikke
pilaf
pilou
pinte
pipet
piton
pitso
pizza
plaak
plano
plebs
pleks
plemp
pleng
plets
plint
plomp
plons
pluis
pluto
poefe
poefs
poker
pokke
polio
polis
polka
polle
polse
polvy
polys
pompe
ponde
pondo
ponte
pools
popel
popes
poppe
popul
porte
porto
poswa
potas
potig
pouke
pouse
praxi
preke
prima
primo
prior
proff
promp
pront
proos
prosa
proue
provo
pruik
pruil
pruim
pruis
pruts
psigo
puber
pukke
pulle
pulse
punte
pupil
purim
puris
putse
pyler
pyper
pypie
quart
rabol
rakke
ramme
rampe
rande
ranke
rante
raspe
ratyn
ravot
ravyn
rayon
rebus
redde
rekke
remme
rente
reuke
ribbe
rieme
rigor
ritme
ritus
robbe
robot
robyn
roede
roeke
roepe
rokke
rolwa
rompe
ronde
rondo
rooms
ropye
rosig
rosyn
rotor
rowwe
ruche
rugge
ruike
ruime
rukke
rukos
rumba
ruspe
ruweg
ryery
rygat
ryles
rylig
rymer
rypad
rypak
ryper
rypes
ryreg
ryrok
rysig
rytyd
ryweg
sakke
saldo
salmi
salms
salvo
samba
sambo
sande
satyn
scala
scudo
seboe
sente
serge
serke
serpe
seuns
shona
sibbe
siejy
sieke
sifon
sigma
signo
sikli
silfe
sinds
sinjo
sinte
sjahs
sjako
sjefs
sjona
sjuut
skade
skadu
skald
skape
skede
skepe
skiry
skist
skoep
skons
skort
skots
skoue
skout
skrae
skram
skrap
skril
skrok
skrop
skrot
skrou
skryn
skuas
skulp
skurk
skuts
skuus
skuwe
slams
slank
slape
slemp
sleuf
slink
sloep
slons
sloof
sloom
sloop
slope
sluik
sluip
sluis
slyts
smake
smalt
smede
smeul
smids
smous
smout
snake
snaps
snede
snees
snobs
snood
sodom
soeke
soepe
sofas
sofis
sokke
soldy
solis
somas
somma
somme
sonde
sonsy
sonte
sonwa
sopor
soppe
sorbe
sosio
sosys
sotho
sotto
spade
spang
spant
speke
sperm
spint
split
splyt
spoeg
spoke
sport
sprak
sprot
spuls
sputa
spyse
spyte
stade
stake
stede
steke
stelp
stilb
stolp
stoma
stond
stonk
stool
stoom
stout
stram
strop
strot
stuik
stuip
stulp
stywe
suede
suide
sujet
sulks
sulle
sulte
sumak
summa
super
supra
sutti
swabe
swalk
swalp
swang
swape
swazi
swede
swepe
swyne
sybas
sybok
sybos
sydak
syfer
syhek
sylig
sylyn
synde
synek
sypad
sypel
syrok
sysag
sysak
sytak
tablo
taboe
tabyn
tafsy
tahrs
takke
talje
talus
tamme
tampa
tande
tante
tappe
tenke
tente
terge
terme
terte
thaba
thars
tiepe
tiere
tifon
tifus
tikke
tilde
timol
timus
tinte
tippe
tissu
tjalk
tjeks
tjilp
tjips
tjirp
tjoek
tjops
tjoue
tjous
togas
togwa
tolke
tombe
tonus
tonyn
tooms
toppe
toque
torso
trede
trips
troje
tromp
tronk
troop
trope
truuk
tsjad
tsjeg
tubas
tulpe
turke
turks
turyn
tutus
uhuru
uidak
uitdy
uitry
ulkus
ulpan
ultra
ureum
uvula
vacuo
vakke
valke
vanne
varke
vasry
vasys
vegwa
velaf
velde
velum
velyn
vente
venyn
villa
vinde
vinke
vinte
viola
viool
virus
vitro
vivat
vlaag
vleug
vloog
vlyme
volke
vomer
vonds
vonke
vonte
vorme
vorms
votum
vrank
vrind
vrome
vryaf
vryer
vryes
vryry
vulle
vurke
vyler
vywer
waens
wakap
wakil
wakis
walms
wande
wanne
wants
wapad
warts
wasig
watts
webbe
wegja
wegry
weide
wende
wenke
werke
wespe
wieke
wiere
wigge
wikke
wilds
winde
wippe
wodan
wodka
woede
woeps
wolke
wonde
worpe
woude
wouel
wrake
wrang
wrong
wuiwe
wulpe
wulps
wulwe
wurms
wybak
wyder
wyses
wysig
xenon
xhosa
yanks
ysbyl
yskas
yskis
yslik
yspak
yspik
yssak
ystyd
ysvos
ysvry
zeboe
`;
